import { registerComponent } from '@gig/magic-common';
import KeycloakLoginSmsComponent from './keycloak-login-sms.vue.js';

var KeycloakLoginSms = registerComponent(KeycloakLoginSmsComponent);

export { KeycloakLoginSms };
